import type { SkeletonOverrides } from "./types";

/**
 * Hand-authored skeleton overrides for Comic Relief.
 *
 * Currently empty: Comic Relief is an experiment to see whether its rounded
 * terminals produce cleaner algorithmic baselines than Andika (fewer of the
 * artifacts we've had to hand-fix for Andika). The baseline is rendered
 * as-is in the inspector; whether any overrides are ever authored here
 * depends on the outcome of that comparison.
 */
const OVERRIDES: SkeletonOverrides = {};

export default OVERRIDES;
